import { combineReducers } from 'redux';

import imageInstruction from './image/imageInstruction';
import textInstruction from './textInstruction';
import noteInstruction from './noteInstruction';
import videoInstruction from './video/videoInstruction';
import audioInstruction from './audio/audioInstruction';
import titleInstruction from './titleInstruction';
import nameScriptInstruction from './nameScriptInstruction';
import webPageInstruction from './webPageInstruction';
import documentPageInstruction from './document-page/documentPageInstruction';

export default combineReducers({
  imageInstruction,
  textInstruction,
  noteInstruction,
  videoInstruction,
  audioInstruction,
  titleInstruction,
  nameScriptInstruction,
  webPageInstruction,
  documentPageInstruction,
});
